export default {
  title: '帳密設置',
  form: {
    account: {
      label: '帳號',
      // placeholder: '請輸入6~50半形英文、數字或是符號',
      placeholder: '請輸入帳號',
      hint: '6~50半形英文、數字或是符號',
      feedback: {
        min: '請輸入6~50半形英文、數字或是符號',
        duplicate: '帳號已存在'
      }
    },
    password: {
      label: '密碼',
      placeholder: '請輸入密碼',
      hint: '8~20半形英文、數字，大小寫需區分',
      feedback: {
        regex: '需包含至少一個大寫、小寫英文及數字，至少包含8位字元',
        accountDuplicate: '密碼不可與帳號相同'
      }
    },
    confirmPassword: {
      label: '確認密碼',
      placeholder: '請輸入密碼',
      hint: '8~20半形英文、數字，大小寫需區分',
      feedback: {
        equal: '請再次輸入相同的密碼'
      }
    },
    submit: '重設密碼'
  },
  resetSuccessfully: '重設成功',
  redirectToLogin: '將導頁至登入頁',
  resetFailed: '重設失敗',
  redundancy: '密碼與上次重複',
  codeInvalid: '驗證碼失效',
  passwordInvalid: '請設定有效密碼'
};
